// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { 
  getFirestore, 
  collection, 
  doc, 
  setDoc, 
  getDoc, 
  getDocs, 
  query, 
  where, 
  serverTimestamp
} from "firebase/firestore"; // Firestore 관련 함수 추가
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBjLVfj3NQnFHillK_KrM2rTydnB-9ZkHQ",
  authDomain: "musizic-f9b06.firebaseapp.com",
  projectId: "musizic-f9b06",
  storageBucket: "musizic-f9b06.firebasestorage.app",
  messagingSenderId: "134893551192",
  appId: "1:134893551192:web:150c3623c0046a298d542d",
  measurementId: "G-V6Z001JX1M"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app); // Firestore 초기화는 기본 데이터베이스로 제한됨
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { db, collection, doc, setDoc, getDoc, getDocs, query, where, serverTimestamp, auth, googleProvider };